import React, { useCallback, useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { AppView, Button, ButtonGroup, CardView, rem, SCROLL_INDICATOR_INSETS, Separator, withAnimatedNavigationHeader, } from 'design-system';
import CardRow from 'design-system/CardRow';
import { IconEmma } from 'design-system/icons';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { SettingsItemIcon } from 'design-system/SettingsItemIcon';
import Status from 'design-system/Status';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { tierThemes } from 'features/premium/benefits';
import { isPremiumTier } from 'features/premium/entities';
import { formatDateForItem } from 'utils';
const strings = {
    beforeYouGo: 'Before you go…',
    youHaveAnActiveSub: 'You have an active subscription, make sure to cancel this first before deleting your account',
    manageSubscriptions: 'Manage subscriptions',
    deleteAnyway: 'Delete anyway',
};
const DeleteActivePremiumSubscriptionScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    const onPressDelete = useCallback(() => {
        navigation.navigateDeprecated('DeleteSuccess');
    }, []);
    const onPressManage = useCallback(() => {
        navigation.popToTop();
        navigation.navigateDeprecated('ManagePremiumSubscription');
    }, []);
    const emmaProStatus = useAppSelector((store) => store.user.user.emmaProStatus);
    useEffect(() => {
        if (!emmaProStatus.tier || !isPremiumTier(emmaProStatus.tier)) {
            onPressDelete();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!emmaProStatus.tier || !isPremiumTier(emmaProStatus.tier)) {
        return null;
    }
    return (<AppView withFrame={false}>
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
            <ScreenInfoHeader title={strings.beforeYouGo} subTitle={strings.youHaveAnActiveSub} smallSubTitle/>
            <CardView noMarginTop>
              <View style={styles.titleRow}>
                <View>
                  <Text Text-20>{tierThemes[emmaProStatus.tier].name}</Text>
                  {emmaProStatus.expiresOn != null && (<Text TextThin-14 Secondary>
                      Renews {formatDateForItem(emmaProStatus.expiresOn)}
                    </Text>)}
                </View>
                <SettingsItemIcon iconSize={44}>
                  <IconEmma />
                </SettingsItemIcon>
              </View>
              <Separator />
              <CardRow small title="Type" info={emmaProStatus.period} infoStyle={styles.info}/>
              <CardRow small title="Status" info={<Status active={emmaProStatus.active} activeText="Active" inactiveText="Expired"/>} infoStyle={styles.info}/>
              <CardRow small title="Payment method" info={emmaProStatus.store === 'stripe'
            ? 'Card'
            : emmaProStatus.store} infoStyle={styles.info}/>
            </CardView>
          </Animated.ScrollView>
          <ButtonGroup type="floating" margins>
            <Button title={strings.manageSubscriptions} brandReversed onPress={onPressManage} testID="manageButton"/>
            <Button title={strings.deleteAnyway} brand onPress={onPressDelete} testID="deleteButton"/>
          </ButtonGroup>
        </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    titleRow: {
        flexDirection: 'row',
        padding: rem(16),
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    info: {
        textTransform: 'capitalize',
    },
});
export default DeleteActivePremiumSubscriptionScreen;
